import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { withLatestFrom } from 'rxjs/operators';
import { SubSink } from 'subsink';

import { TopnavInfoService } from '../menuInterfaces/topnav-info.service';

@Component({
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent implements OnDestroy {
    subs = new SubSink();
    constructor(
        private info: TopnavInfoService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.subs.add(
             info.routesUpdated$.subscribe(v => {
                // console.log('Routes Loaded');
                let url = '/';
                if (this.route.snapshot.pathFromRoot.length > 0) {
                    url = this.route.snapshot.url.reduce(
                        (acc, row) => `${acc}/${row.path}`,
                        ''
                    );
                }
                if (url === '/Loading') {
                    console.log('Navigating: loading.component', this.route.snapshot.queryParams.sourceDocID);
                    url = '/';
                    if(this.route.snapshot.queryParams.sourceDocID)
                    {
                        this.router.navigate(['ACL','DocumentView',decodeURI( this.route.snapshot.queryParams.sourceDocID)], { queryParamsHandling: 'merge' });
                    }
                    else
                        this.router.navigate([url], { queryParamsHandling: 'merge' });
                }
                else
                    this.router.navigate([url], { queryParamsHandling: 'merge' });
                
                
            })
        );
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
